angular.module('unica_check.check_services')

.factory('CheckService', function ($http, getBaseApiURL) {

	var CheckService = {};

	CheckService.checkInInvitation = function (hash) {
		var url  = getBaseApiURL + '/check/check-in-invitation';

		return $http({
			method: 'post',
			url: url,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	CheckService.checkInWorkshop = function (hash) {
		var url  = getBaseApiURL + '/check/check-in-workshop';

		return $http({
			method: 'post',
			url: url,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	CheckService.saveCheckOutInvitation = function (hash) {
		var url  = getBaseApiURL + '/check/save-check-out-invitation';

		return $http({
			method: 'post',
			url: url,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	CheckService.checkOutWorkshop = function (hash) {
		var url  = getBaseApiURL + '/check/check-out-workshop';

		return $http({
			method: 'post',
			url: url,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	CheckService.checkOutInvitation = function (hash) {
		var url  = getBaseApiURL + '/check/check-out-invitation';

		return $http({
			method: 'post',
			url: url,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	return CheckService;
});